module.exports = __webpack_public_path__ + "img/not-win-icon@2x.930824fe.png";